/*
 * Keeps checkout-level URL discounts visible in Rebuy Smart Cart while
 * preventing a second code from being entered for URL-only campaigns.
 */
window.URLDiscountManager = (function () {
  const LOCKED_LABEL = 'RABATTCODE ANGEWENDET!';
  let debug = false;
  let discountContainerObserver = null;
  let observedContainer = null;
  let urlTagWasVisible = false;
  let refreshTimer = null;
  let isSuspended = false;

  function log(...args) {
    if (debug) console.log('[URLDiscountManager]', ...args);
  }

  function getURLDiscountCode() {
    const cookies = document.cookie.split(';');
    const discountCookie = cookies.find(cookie => cookie.trim().startsWith('discount_code='));
    if (!discountCookie) return null;

    const value = discountCookie.split('=').slice(1).join('=').trim();
    return value && value !== 'undefined' ? value.toUpperCase() : null;
  }

  function clearURLDiscountCookie() {
    document.cookie = 'discount_code=; Max-Age=0; path=/';
  }

  function hasVisibleURLTag(code) {
    return Array.from(document.querySelectorAll('.rebuy-cart__discount-tag')).some(tag => {
      if (tag.offsetParent === null) return false;
      return tag.textContent.toUpperCase().includes(code);
    });
  }

  function restoreDisclosure(disclosure, wrapper) {
    wrapper.classList.remove('bwb-url-discount-locked');

    const label = disclosure.querySelector('.rebuy-cart__discount-summary-label');
    if (label?.dataset.urlDiscountOriginalLabel) {
      label.textContent = label.dataset.urlDiscountOriginalLabel;
      delete label.dataset.urlDiscountOriginalLabel;
    }

    const arrow = disclosure.querySelector('.rebuy-cart__discount-summary-arrow');
    if (arrow) arrow.style.removeProperty('display');
  }

  function lockDisclosure(disclosure, wrapper) {
    wrapper.classList.add('bwb-url-discount-locked');
    disclosure.open = false;

    const label = disclosure.querySelector('.rebuy-cart__discount-summary-label');
    if (label) {
      if (!label.dataset.urlDiscountOriginalLabel) {
        label.dataset.urlDiscountOriginalLabel = label.textContent.trim();
      }
      label.textContent = LOCKED_LABEL;
    }

    // Rebuy can redraw this arrow with an inline style, so use an inline
    // important declaration and repeat it after container mutations.
    const arrow = disclosure.querySelector('.rebuy-cart__discount-summary-arrow');
    if (arrow) arrow.style.setProperty('display', 'none', 'important');
  }

  function observeDiscountContainer(wrapper) {
    if (observedContainer === wrapper) return;

    discountContainerObserver?.disconnect();
    observedContainer = wrapper;
    discountContainerObserver = new MutationObserver(() => {
      if (refreshTimer) return;
      refreshTimer = setTimeout(() => {
        refreshTimer = null;
        manageDiscountInput();
      }, 0);
    });
    discountContainerObserver.observe(wrapper, { childList: true, subtree: true });
  }

  function manageDiscountInput() {
    if (isSuspended) {
      log('URL discount handling is suspended while a bundle discount is active');
      return;
    }

    const wrapper = document.querySelector('[data-rebuy-component="discount-input"]');
    if (!wrapper) return;

    // Clear the legacy manager's whole-container hiding if this asset is
    // reloaded after an older version during a Rebuy redraw.
    wrapper.style.removeProperty('display');
    observeDiscountContainer(wrapper);

    const disclosure = wrapper.querySelector('.rebuy-cart__discount-disclosure');
    if (!disclosure) return;

    const code = getURLDiscountCode();
    if (!code) {
      urlTagWasVisible = false;
      restoreDisclosure(disclosure, wrapper);
      return;
    }

    if (hasVisibleURLTag(code)) {
      urlTagWasVisible = true;
    } else if (urlTagWasVisible) {
      // Only clear the cookie after Rebuy has rendered, then removed, this
      // specific URL tag. A delayed initial render must keep the URL state.
      clearURLDiscountCookie();
      urlTagWasVisible = false;
      restoreDisclosure(disclosure, wrapper);
      return;
    }

    lockDisclosure(disclosure, wrapper);
  }

  return {
    init: function () {
      if (!window.RebuyEventManager) {
        console.error('[URLDiscountManager] RebuyEventManager not available');
        return this;
      }

      window.RebuyEventManager.on('cart:show', manageDiscountInput)
        .on('cart:change', manageDiscountInput)
        .on('cart:ready', manageDiscountInput);
      window.addEventListener('pageshow', manageDiscountInput);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') manageDiscountInput();
      });
      document.addEventListener('toggle', event => {
        if (
          getURLDiscountCode() &&
          event.target.matches?.('.rebuy-cart__discount-disclosure')
        ) {
          event.target.open = false;
        }
      }, true);

      manageDiscountInput();
      return this;
    },

    refresh: function () {
      isSuspended = false;
      manageDiscountInput();
      return this;
    },

    suspend: function () {
      isSuspended = true;
      return this;
    },

    debug: function (enabled) {
      debug = enabled;
      log('Debug logging', enabled ? 'enabled' : 'disabled');
      return this;
    },
  };
})();
